import React, { useState } from "react";
import LogoLayout from "../../../components/logolayout/logolayout";
import SelectInput from "../../../components/form/inputs/select-input/select-input";
import TextInput from "../../../components/form/inputs/text-input/text-input";
// Import ajouté
import countriesJson from "../../../data/countries.json";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { useAppContext } from "../../../context/app.context";
import {
    cleanPhoneNumber,
  emailReg,
  formatPhone,
  passwordReg,
  phonereg,
  showToast,
} from "../../../utils/utils";
import CheckBoxInput from "../../../components/form/inputs/check-input/check-input";
import Modal from "../../../components/modal/modal";
import axiosInstance from "../../../config/axios";
import DateTimeInput from "../../../components/form/inputs/datetime-input/date-time-input";

interface RegisterSignupPageProps {
  formData?: any;
  onNext?: (data: any) => void;
  onBack?: () => void;
}

export default function RegisterStep4Page({
  formData,
  onNext,
  onBack,
}: RegisterSignupPageProps) {
  const [search, setSearch] = useState("");
  const [showmodal, setshowmodal] = useState(false);
  const navigate = useNavigate();
  const { state } = useLocation();
  const [checked, setchecked] = useState(false);
  const passwordRules = [
    "Plus de 8 caractères",
    "Au minimum une majuscule et une minuscule",
    "Doit contenir un chiffre et un caractère spécial",
  ];

  const { appInfos, setAppInfos } = useAppContext();

  // Calcul des dates min/max pour la date de naissance
  const today = new Date();
  const minBirthDate = new Date();
  minBirthDate.setFullYear(today.getFullYear() - 100); // 100 ans maximum
  const maxBirthDate = new Date();
  maxBirthDate.setFullYear(today.getFullYear() - 18); // 18 ans minimum

  async function onSubmit(form: any) {
    try {
     
      await axiosInstance.post(`auth/signup/finish`, { ...form,phone_number:cleanPhoneNumber(form?.phone), ...state });
      navigate("/register/success", { state: { ...form,phone_number:cleanPhoneNumber(form?.phone) ,...state } });
      setAppInfos({ formState: { ...form, ...state } });
    } catch (e: any) {
      if (e.response?.data?.error === "user signup already finished")
        showToast("Utilisateur déjà inscrit");
      else showToast("Une erreur s'est produite");
    }
  }

  if (!state || (state && Object.keys(state).length == 0))
    return <Navigate replace to="/register" />;

  return (
    <LogoLayout onSubmit={onSubmit} submitTitle="Suivant" progress={85}>
     <div className="d-flex flex-grow-1 flex-column">
      <TextInput
        name="first_name"
        required="Nom est requis"
        placeHolder="Nom"
        value={appInfos.formState.firstName}
        label="Nom*"
      />
      <TextInput
        name="last_name"
        required="Prénom est requis"
        placeHolder="Prénom"
        value={appInfos.formState.lastName}
        label="Prénom*"
      />

      {/* Date de naissance avec DateTimeInput */}
      <DateTimeInput
        name="birth_date"
        type="date"
        required="La date de naissance est requise"
        value={appInfos.formState.birthDate}
        label="Date de naissance*"
        min={minBirthDate}
        max={maxBirthDate}
        placeholder="JJ/MM/AAAA"
      />

      {/* Numéro de téléphone */}
      <TextInput
        validate={(val: any) =>
          !phonereg.test(val?.replace(/\D/g, "")) ? "Téléphone invalide" : true
        }
        name="phone"
        value={appInfos.formState.phone}
        format={formatPhone}
        maxLength={14}
        placeHolder="06.00.00.00.00"
        label="Téléphone*"
        required="Le numéro de téléphone est requis"
      />
      </div> 
    </LogoLayout>
  );
}
